import { render, staticRenderFns } from "./InvestmentLedger.vue?vue&type=template&id=75c88a22"
import script from "./InvestmentLedger.vue?vue&type=script&lang=js"
export * from "./InvestmentLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports